import React from 'react';
import Button, { ButtonProps } from '../../atoms/Button';
import Modal, { ModalProps } from '../../molecules/Modal';

export interface Props extends Omit<ModalProps, 'id'> {
  onConfirm: () => Promise<void> | void;
  onCancel?: () => Promise<void> | void;
  // Text overrides
  confirmLabel?: string;
  cancelLabel?: string;
  cancelBtnClassName?: string;
  confirmBtnClassName?: string;
  // Color overrides
  cancelBtnColor?: ButtonProps['color'];
  confirmBtnColor?: ButtonProps['color'];
}

/**
 * <ConfirmationModal> component
 */
const ConfirmationModal: React.FunctionComponent<Props> = ({
  onHide,
  children,
  cancelBtnClassName = '',
  confirmBtnClassName = '',
  cancelBtnColor,
  confirmBtnColor,
  onConfirm,
  onCancel,
  confirmLabel = 'Sim',
  cancelLabel = 'Cancelar',
  ...modalProps
}) => {
  /**
   * Handles the confirmation case.
   */
  const handleConfirm = async () => {
    await onConfirm();
    onHide?.();
  };

  /**
   * Handles the cancel case.
   */
  const handleCancel = async () => {
    if (onCancel) await onCancel();
    onHide?.();
  };

  return (
    <Modal
      id="confirmation-modal"
      onHide={onHide}
      footer={
        <div className="d-flex flex-justify-end gap-3">
          <Button
            variant="link"
            onClick={handleCancel}
            className={cancelBtnClassName}
            color={cancelBtnColor}
            size="lg"
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={handleConfirm}
            className={confirmBtnClassName}
            color={confirmBtnColor}
            size="lg"
          >
            {confirmLabel}
          </Button>
        </div>
      }
      {...modalProps}
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModal;
